function Namibia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1718)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M4.68634 27.3147C5.35752 27.9859 6.07365 28.5845 6.82483 29.1115L29.1104 6.82581C28.5835 6.07463 27.9849 5.3585 27.3136 4.68731C26.6425 4.01613 25.9263 3.41763 25.1751 2.89062L2.88965 25.1763C3.41659 25.9273 4.01515 26.6435 4.68634 27.3147Z" fill="#A2001D"/>
  <path d="M4.68632 4.68556C-0.361432 9.73331 -1.33043 17.3141 1.77726 23.3354L23.3361 1.77662C17.3148 -1.33107 9.73395 -0.361945 4.68632 4.68556Z" fill="#0052B4"/>
  <path d="M27.3136 27.3139C32.3613 22.2663 33.3303 14.6855 30.2227 8.66406L8.66382 30.223C14.6851 33.3306 22.266 32.3616 27.3136 27.3139Z" fill="#496E2D"/>
  <path d="M13.2174 9.04308L11.4245 9.88639L12.3793 11.6228L10.4325 11.2504L10.1857 13.217L8.82971 11.7705L7.47364 13.217L7.22702 11.2504L5.28014 11.6227L6.23483 9.88633L4.44202 9.04308L6.23489 8.19971L5.28014 6.46345L7.22696 6.83583L7.47371 4.86914L8.82971 6.31564L10.1858 4.86914L10.4325 6.83583L12.3793 6.46345L11.4246 8.19977L13.2174 9.04308Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Namibia;
